<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>배너 관리</div>
            </strong>
          </div>
          <div class="mb-2 ml-2">
            <span >
              <b>팝업 배너</b>
            </span>
          </div>
          <div class="">
            <bannerPopUpForm v-bind:queryParams="popupBanner" ref="popupBannerRef"></bannerPopUpForm>
          </div>
          <div class="mb-2 ml-2 pt-4">
            <span >
              <b>최상단 배너</b>
            </span>
          </div>
          <div>
            <bannerTopForm v-bind:queryParams="topBanner" ref="topBannerRef"></bannerTopForm>
          </div>
          <div class="mb-2 ml-2 pt-4">
            <span >
              <b>중간 배너</b>
            </span>
          </div>
          <div>
            <bannerMiddleForm v-bind:queryParams="middleBanner1" v-bind:middle_index="'1'" ref="middleBanner1Ref"></bannerMiddleForm>
            <bannerMiddleForm v-bind:queryParams="middleBanner2" v-bind:middle_index="'2'" ref="middleBanner2Ref"></bannerMiddleForm>
            <bannerMiddleForm v-bind:queryParams="middleBanner3" v-bind:middle_index="'3'" ref="middleBanner3Ref"></bannerMiddleForm>
            <bannerMiddleForm v-bind:queryParams="middleBanner4" v-bind:middle_index="'4'" ref="middleBanner4Ref"></bannerMiddleForm>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                  <!-- <b-button variant="success" v-on:click="insertExtBanner()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 초기화</h5></b-button> -->
                </b-col>
                <b-col md="4">
                  <b-button variant="success" v-on:click="saveExtBanner()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 적용</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/letter/newsletter'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import swal from 'sweetalert2'
import bannerPopUpForm from './BannerPopUpForm'
import bannerTopForm from './BannerTopForm'
import bannerMiddleForm from './BannerMiddleForm'
const moment = require("moment");

export default {
  components: {
      bannerPopUpForm
    , bannerTopForm
    , bannerMiddleForm
  },
  data() {
    return {
      newFlag:'new',
      formtype: '',
      popupBanner:{
        banner_code : 'BANSMN20200010', // 변경불가
        banner_type : 'popupbanner',  // 변경불가
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(3, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
        active_yn: 'Y',
        landing_url:'',
        listThumbnailFile:[],
        formValidation:false,
        contents_type: '1',
        contents_html:'',

      },
      topBanner:{
        banner_code : 'BANSMN20200011',  // 변경불가
        banner_type : 'topbanner',  // 변경불가
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(3, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
        active_yn: 'Y',
        landing_url:'',
        listThumbnailFile:[],
        formValidation:false,
        contents_type: '1',
      },
      middleBanner1:{
        banner_code : 'BANSMN20200012', // 변경불가
        banner_type : 'middlebanner', // 변경불가
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(3, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
        active_yn: 'Y',
        landing_url:'',
        listThumbnailFile:[],
        formValidation:false,
        contents_type: '1',
        slot_number:1,
      },
      middleBanner2:{
        banner_code : 'BANSMN20200013', // 변경불가
        banner_type : 'middlebanner', // 변경불가
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(3, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
        active_yn: 'Y',
        landing_url:'',
        listThumbnailFile:[],
        formValidation:false,
        contents_type: '1',
        slot_number:2,
      },
      middleBanner3:{
        banner_code : 'BANSMN20200014', // 변경불가
        banner_type : 'middlebanner', // 변경불가
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(3, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
        active_yn: 'Y',
        landing_url:'',
        listThumbnailFile:[],
        formValidation:false,
        contents_type: '1',
        slot_number:3,
      },
      middleBanner4:{
        banner_code : 'BANSMN20200015', // 변경불가
        banner_type : 'middlebanner', // 변경불가
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(3, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
        active_yn: 'Y',
        landing_url:'',
        listThumbnailFile:[],
        formValidation:false,
        contents_type: '1', // banner_type / file_code_check
        slot_number:4,
      },
      queryParams: {
        popupBanner:{},
        topBanner:{},
        middleBanner1:{},
        middleBanner2:{},
        middleBanner3:{},
        middleBanner4:{},
      },
      enabled: true,
    }
  },
  watch: {
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.formtype = self.$route.query.status;

    this.$http.get('/api/select/extBannerList?access_token='+token)
    .then((result) => {

      for(var i=0; i<result.data.length; i++ ){
        console.log(result.data[i].banner_code);
        switch (result.data[i].banner_code) {
          case 'BANSMN20200010':
            this.initFormData(result.data[i], this.popupBanner);
            break;
          case 'BANSMN20200011':
            this.initFormData(result.data[i], this.topBanner);
            break;
          case 'BANSMN20200012':
            this.initFormData(result.data[i], this.middleBanner1);
            break;
          case 'BANSMN20200013':
            this.initFormData(result.data[i], this.middleBanner2);
            break;
          case 'BANSMN20200014':
            this.initFormData(result.data[i], this.middleBanner3);
            break;
          case 'BANSMN20200015':
            this.initFormData(result.data[i], this.middleBanner4);
            break;
          default:
        }
      }
    })
  },
  methods: {
    initFormData(db, local){
      local.banner_code = db.banner_code;
      local.banner_type = db.banner_type;
      local.start_date = db.start_date;
      local.end_date = db.end_date;
      local.reg_date = db.reg_date;
      local.active_yn = db.active_yn;
      local.landing_url = db.landing_url;
      if(db.contents_type == 'img'){
        local.contents_type = '1'
      }else{
        local.contents_type = '2'
      }
      local.img_url = db.img_url;
      local.img_width = db.img_width;
      local.img_height = db.img_height;
      local.contents_html = db.contents_html;
      local.listThumbnailFile = [];
      var file = {};
      file.file_url = local.img_url;
      file.file_height = local.img_height;
      file.file_width = local.img_width;
      local.listThumbnailFile.push(file);


    },
    saveExtBanner(){

      if(this.queryParams.middleBanner1.active_yn == 'N' &&
         this.queryParams.middleBanner2.active_yn == 'N' &&
         this.queryParams.middleBanner3.active_yn == 'N' &&
         this.queryParams.middleBanner4.active_yn == 'N'  ){

           swal.fire({
             type: 'warning',
             title: '중간 배너는 한개이상 활성화 되어 있어야 합니다.',
             showConfirmButton: false,
             timer: 3500
           })

           return;
      }

        console.log("[saveExtBanner]=============================================");
        this.queryParams.popupBanner = this.popupBanner;
        this.queryParams.topBanner = this.topBanner;
        this.queryParams.middleBanner1 = this.middleBanner1;
        this.queryParams.middleBanner2 = this.middleBanner2;
        this.queryParams.middleBanner3 = this.middleBanner3;
        this.queryParams.middleBanner4 = this.middleBanner4;

        var queryParams2 = [];
        queryParams2.push(this.popupBanner);
        queryParams2.push(this.topBanner);
        queryParams2.push(this.middleBanner1);
        queryParams2.push(this.middleBanner2);
        queryParams2.push(this.middleBanner3);
        queryParams2.push(this.middleBanner4);

        console.log(this.queryParams);
        this.$refs.topBannerRef.validateCheckFN();
        this.$refs.popupBannerRef.validateCheckFN();
        this.$refs.middleBanner1Ref.validateCheckFN();
        this.$refs.middleBanner2Ref.validateCheckFN();
        this.$refs.middleBanner3Ref.validateCheckFN();
        this.$refs.middleBanner4Ref.validateCheckFN();

        var self = this;
        setTimeout(function(){

          if(self.queryParams.topBanner.formValidation
              & self.queryParams.popupBanner.formValidation
              & self.queryParams.middleBanner1.formValidation
              & self.queryParams.middleBanner2.formValidation
              & self.queryParams.middleBanner3.formValidation
              & self.queryParams.middleBanner4.formValidation
          ){

            var token = sessionStorage.getItem("myToken");
            var param = encodeURI(JSON.stringify(queryParams2));
            var data = new FormData();
            data.append('objs', param);
            self.$http.post('/api/update/extBanners?access_token=' + token, data, null)
            .then((result) => {
              console.log('성공');
              swal.fire({
                type: 'success',
                title: '저장성공',
                showConfirmButton: false,
                timer: 1500
              }).then(function() {
                  // window.location = "#/main/mainmanagement";
              });
            })

          }else{
            console.log('실패');
            swal.fire({
              type: 'warning',
              title: '필수 입력값이 불충분합니다.',
              showConfirmButton: false,
              timer: 3500
            })
          }

      }, 1100);
    },
    insertExtBanner(){
      console.log("[insertExtBanner]=============================================");
      this.queryParams.popupBanner = this.popupBanner;
      this.queryParams.topBanner = this.topBanner;
      this.queryParams.middleBanner1 = this.middleBanner1;
      this.queryParams.middleBanner2 = this.middleBanner2;
      this.queryParams.middleBanner3 = this.middleBanner3;
      this.queryParams.middleBanner4 = this.middleBanner4;


      var queryParams2 = [];
      queryParams2.push(this.popupBanner);
      queryParams2.push(this.topBanner);
      queryParams2.push(this.middleBanner1);
      queryParams2.push(this.middleBanner2);
      queryParams2.push(this.middleBanner3);
      queryParams2.push(this.middleBanner4);

      console.log(this.queryParams);
      this.$refs.topBannerRef.validateCheckFN();
      this.$refs.popupBannerRef.validateCheckFN();
      this.$refs.middleBanner1Ref.validateCheckFN();
      this.$refs.middleBanner2Ref.validateCheckFN();
      this.$refs.middleBanner3Ref.validateCheckFN();
      this.$refs.middleBanner4Ref.validateCheckFN();

      var self = this;
      setTimeout(function(){

        if(self.queryParams.topBanner.formValidation
            & self.queryParams.popupBanner.formValidation
            & self.queryParams.middleBanner1.formValidation
            & self.queryParams.middleBanner2.formValidation
            & self.queryParams.middleBanner3.formValidation
            & self.queryParams.middleBanner4.formValidation
        ){

          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(queryParams2));
          var data = new FormData();
          data.append('objs', param);
          self.$http.post('/api/insert/extBanners?access_token=' + token, data, null)
          .then((result) => {
            console.log('성공');
            swal.fire({
              type: 'success',
              title: '저장성공',
              showConfirmButton: false,
              timer: 1500
            }).then(function() {
                // window.location = "#/main/mainmanagement";
            });
          })

        }else{
          console.log('실패');
          swal.fire({
            type: 'warning',
            title: '필수 입력값이 불충분합니다.',
            showConfirmButton: false,
            timer: 3500
          })
        }

    }, 1100);
    }
  }
}

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}



// WEBPACK FOOTER //
// src/views/main/BannerManagement.vue